var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeRewilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3178_14246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9087 21.3249C4.72631 18.1145 4.04606 14.902 2.86669 11.6856C2.60137 10.962 3.52223 10.3975 4.04667 10.9623C5.22342 12.2295 6.18408 13.535 6.92723 14.8776C6.52294 12.1937 5.871 9.35154 4.97095 6.35131C4.76737 5.6727 5.57869 5.1507 6.11189 5.61725C8.41247 7.63025 10.0364 10.3442 10.9878 13.7447C12.2317 9.41501 14.525 5.65011 17.8656 2.46139C18.4017 1.94961 19.2634 2.50442 19.0195 3.20426C17.3888 7.88361 16.2772 12.0385 15.6825 15.6658C16.7157 14.0177 18.164 12.4277 20.0219 10.8977C20.6104 10.413 21.443 11.0763 21.102 11.7582C19.5037 14.9549 18.6007 18.1425 18.389 21.3249H23.2942C23.684 21.3249 24 21.6409 24 22.0308C24 22.4207 23.684 22.7367 23.2942 22.7367H0.705891C0.316031 22.7367 0 22.4207 0 22.0308C0 21.6409 0.316031 21.3249 0.705891 21.3249H4.9087ZM13.7575 21.3249C13.7698 17.0992 14.7369 11.9431 16.6544 5.84853C13.2117 10.0967 11.4289 15.2473 11.3015 21.3249H13.7575ZM10.2529 17.1058C9.75577 13.7252 8.70867 10.9569 7.11511 8.78848C8.27934 13.3287 8.85309 17.5073 8.83411 21.325H9.88941C9.91884 19.866 10.0399 18.4595 10.2529 17.1058ZM5.35983 14.9892C5.88675 17.0999 6.2078 19.212 6.32264 21.325H7.3927C7.27378 19.1332 6.5985 17.0231 5.35983 14.9892ZM16.9743 21.3249C17.1203 18.9899 17.6156 16.6574 18.4591 14.3287C16.4558 16.5748 15.3769 18.9049 15.2019 21.3249H16.9743Z",
    fill: "#78BB96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3178_14246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeRewilding);
export default __webpack_public_path__ + "static/media/project-type-rewilding.6c5c0d8b6e68c856d382592f2f87370b.svg";
export { ForwardRef as ReactComponent };